var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5238,3.90477c-4.59271,0-8.25848.98883-9.52386,2.55743C10.73438,4.89366,7.0683,3.90477,2.47614,3.90477A.47618.47618,0,0,0,2,4.381V16.28569a.47618.47618,0,0,0,.47614.4762c5.21282,0,9.04766,1.373,9.04766,2.85717a.47617.47617,0,0,0,.95234,0c0-1.48425,3.83416-2.85717,9.04766-2.85717A.47624.47624,0,0,0,22,16.28569V4.381A.47624.47624,0,0,0,21.5238,3.90477ZM2.95233,15.8131V4.861c4.96851.08062,8.57147,1.41479,8.57147,2.85333V17.90666C10.02081,16.65977,6.85669,15.87206,2.95233,15.8131Zm18.09528,0c-3.90467.059-7.06861.84661-8.57147,2.09344V7.71428c0-1.43866,3.60235-2.77277,8.57147-2.85333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83136,8.469a14.20729,14.20729,0,0,0-4.9325-1.22907.4762.4762,0,1,0-.08349.94873A13.301,13.301,0,0,1,9.40668,9.32146.4762.4762,0,0,0,9.83136,8.469Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83136,14.18327a14.2073,14.2073,0,0,0-4.9325-1.22906.4762.4762,0,1,0-.08349.94873,13.30119,13.30119,0,0,1,4.59131,1.13281.4762.4762,0,0,0,.42468-.85248Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83136,11.32616a14.20729,14.20729,0,0,0-4.9325-1.22907.47617.47617,0,1,0-.08349.94867,13.30255,13.30255,0,0,1,4.59131,1.13281.47617.47617,0,1,0,.42468-.85241Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.59326,15.03575a13.30113,13.30113,0,0,1,4.59131-1.13281.4762.4762,0,1,0-.0835-.94873,14.2073,14.2073,0,0,0-4.93249,1.22906.4762.4762,0,0,0,.42468.85248Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.59326,9.32146a13.30089,13.30089,0,0,1,4.59131-1.13282.4762.4762,0,1,0-.0835-.94873A14.20729,14.20729,0,0,0,14.16858,8.469a.4762.4762,0,0,0,.42468.85248Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.59326,12.17857a13.30249,13.30249,0,0,1,4.59131-1.13281.47617.47617,0,1,0-.0835-.94867,14.20729,14.20729,0,0,0-4.93249,1.22907.47617.47617,0,1,0,.42468.85241Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.c43aaac53575cf64d26eed25e42a16c3.svg";
export { ForwardRef as ReactComponent };